import { Backdrop, createStyles, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import ProgressBox from '@/hocs/withGlobalBackdrop/components/ProgressBox';
import { makeSelectLoadingState } from '@/model/global/selectors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: '#ffffff',
    },
  }),
);

const noop = (e: Event): void => {
  e.preventDefault();
  e.stopPropagation();
};

const selectViewState = makeSelectLoadingState();

const GlobalBackdrop: React.FC = () => {
  const classes = useStyles();
  const { loading, messageId } = useSelector(selectViewState);
  useEffect(() => {
    if (loading) {
      window.addEventListener('keyup', noop, false);
      window.addEventListener('keydown', noop, false);
    }
    return (): void => {
      window.removeEventListener('keyup', noop, false);
      window.removeEventListener('keydown', noop, false);
    };
  }, [loading]);

  return loading ? (
    <Backdrop className={classes.backdrop} open={loading} data-test="backdrop-container">
      <ProgressBox data-test="backdrop-content" operation={messageId && <FormattedMessage id={`${messageId}`} />} />
    </Backdrop>
  ) : (
    <></>
  );
};

export default GlobalBackdrop;
